import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"
import LocationData from "./LocationModel/LocationData"

export default function LocationUpdateObservable(data: LocationData): Observable<string> {
  const requestBody: string = JSON.stringify(data)
  return ObservableFromFetch<string>("FFOrderClientFileMaintenance/UpdateLocationInformation", requestBody)
}
